import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import SEO from '../components/SEO/SEO';
import LatestPost from '../components/LatestPost/LatestPost';
import LatestNews from '../components/LatestNews/LatestNews';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import capitalizeWords from '../utils/capitalizeWords';
import { useCategoryArticles, useArticlesByTag } from '../api/fetchExampleData';

const CategoryPage = () => {
    const { '*': categoryPath, tagSlug } = useParams();
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState(1);
    const [articles, setArticles] = useState([]);
    const [meta, setMeta] = useState({});
    const [latestPostArticles, setLatestPostArticles] = useState([]);
    const [latestNewsArticles, setLatestNewsArticles] = useState([]);

    // Determina se è una pagina tag o categoria
    const isTagPage = location.pathname.startsWith('/tags');

    // Query API
    const { data: response } = isTagPage
        ? useArticlesByTag({ tag: tagSlug, page: currentPage, perPage: 10 })
        : useCategoryArticles({ category: categoryPath, page: currentPage, perPage: 10 });

    // Aggiorna gli articoli al caricamento dei dati
    useEffect(() => {
        if (response?.data) {
            const newArticles = response.data;

            if (currentPage === 1) {
                setArticles(newArticles);
                setLatestPostArticles(newArticles.slice(0, 4));
                setLatestNewsArticles(newArticles.slice(4));
            } else {
                setArticles((prev) => [...prev, ...newArticles]);
                setLatestNewsArticles((prev) =>
                    [...prev, ...newArticles].filter(
                        (article, index, self) => self.findIndex((a) => a.id === article.id) === index
                    )
                );
            }

            setMeta(response.meta || {});
        }
    }, [response, currentPage]);

    const handleLoadMore = () => {
        if (meta.total_pages && currentPage < meta.total_pages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const pageTitle = isTagPage
        ? `Articoli per il tag: ${capitalizeWords(tagSlug.replace(/-/g, ' '))}`
        : `Articoli nella categoria: ${capitalizeWords(categoryPath.split('/').pop())}`;

    return (
        <>
            <Breadcrumb />
            <SEO
                title={pageTitle}
                description={`Scopri gli ultimi articoli per ${isTagPage ? `il tag ${tagSlug}` : `la categoria ${categoryPath}`}`}
                image={articles[0]?.image || '/default-image.jpg'}
                url={location.pathname}
            />
            {latestPostArticles.length > 0 && <LatestPost articles={latestPostArticles} />}
            {latestNewsArticles.length > 0 && (
                <LatestNews
                    articles={latestNewsArticles}
                    meta={meta}
                    onLoadMore={handleLoadMore}
                    title={pageTitle}
                />
            )}
        </>
    );
};

export default CategoryPage;
